/* Global handler for the cart-drawer upsell toggle checkbox.
   Called via onchange="toggleCartUpsell(this)" in cart-upsell-toggle.liquid.
   Mirrors the toggleGolfClub pattern from main-product-42.js exactly:
   - locale-safe Shopify.routes.root prefix
   - sections + sections_url params for Section Rendering API morph
   - cart:update CustomEvent so cart-items-component / cart-icon-component refresh in-place
   - item.key (not variant_id) for cart/change.js removal
   - checkbox state reverted on error
   - loading state: checkbox disabled + track opacity while fetch is in flight */

window.toggleCartUpsell = function(checkbox) {
  var variantId = parseInt(checkbox.dataset.cartUpsellProductId, 10);
  if (!variantId) return;

  var checked = checkbox.checked;
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, '/');
  var track = checkbox.nextElementSibling;

  checkbox.disabled = true;
  if (track) { track.style.opacity = '0.45'; track.style.pointerEvents = 'none'; }

  function done() {
    checkbox.disabled = false;
    if (track) { track.style.opacity = ''; track.style.pointerEvents = ''; }
  }

  var sectionIds = new Set();
  document.querySelectorAll('cart-items-component, cart-icon-component').forEach(function(el) {
    if (el.dataset && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
  });
  var sectionsParam = Array.from(sectionIds).join(',');

  function dispatchUpdate(cart, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'cart-upsell-toggle',
        data: { source: 'cart-upsell-toggle', itemCount: (cart && cart.item_count) || 0, sections: sections || null }
      }
    }));
  }

  if (checked) {
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionsParam) { body.sections = sectionsParam; body.sections_url = window.location.pathname; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      return fetch(root + 'cart.js').then(function(r) {
        return r.json().then(function(cart) { return { cart: cart, sections: data.sections || null }; });
      });
    })
    .then(function(result) {
      dispatchUpdate(result.cart, result.sections);
      done();
    })
    .catch(function(e) {
      console.error('[toggleCartUpsell] add failed:', e);
      checkbox.checked = false;
      done();
    });
  } else {
    fetch(root + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var item = cart.items.find(function(i) { return i.variant_id === variantId; });
      if (!item) { dispatchUpdate(cart, null); done(); return; }

      var body = { id: item.key, quantity: 0 };
      if (sectionsParam) { body.sections = sectionsParam; body.sections_url = window.location.pathname; }

      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.json(); })
      .then(function(updated) {
        dispatchUpdate(updated, updated.sections || null);
        done();
      });
    })
    .catch(function(e) {
      console.error('[toggleCartUpsell] remove failed:', e);
      checkbox.checked = true;
      done();
    });
  }
};
